import { Requests } from "../common/request.common";
import { AgencyUserResponseTypes } from "../common/response.common";
import { get, post } from "./common";

export const agencyUser = {
    record(data: typeof Requests.AgencyUser.Record.Input) {
        return post<typeof data, AgencyUserResponseTypes.Record>("/agency-user/record", data);
    },
    obtain(id: string) {
        return get<AgencyUserResponseTypes.Obtain>(`/agency-user/obtain/${id}`);
    },
    create(data: typeof Requests.AgencyUser.Create.Input) {
        return post<typeof data>("/agency-user/create", data);
    },
    update(agencyId: string, data: typeof Requests.AgencyUser.Update.Input) {
        return post<typeof data>(`/agency-user/update/${agencyId}`, data);
    },
    updatePassword(agencyId: string, data: typeof Requests.AgencyUser.UpdatePassword.Input) {
        return post<typeof data>(`/agency-user/update-password/${agencyId}`, data);
    },
};
